const setBasePath = (nodes, path) => {
  //   console.log(nodes);
  //   console.log(path);
  return nodes.map((element) => {
    return { ...element, basePath: path, key: `${path}${element.title}` };
  });
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { config } = action.payload;
    const nodes = markActivePathSideBar(config, '', null);
    const indexed = nodes.reduce(register, []);

    inactiveAll(nodes);

    return {
      ...state,
      isInitialized: true,
      nodes,
      indexed
    };
  },
  ACTIVATE: (state, action) => {
    const { nodes, active } = action.payload;

    return {
      ...state,
      nodes
    };
  },
  AUTHORIZE: (state, action) => {
    const { authorized } = action.payload;
    return {
      ...state,
      authorized: authorized
    };
  }
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const markActivePathSideBar = (routes, basePath, location) => {
  return routes.map((element) => {
    const children = element.children;
    let locked = false;
    return {
      ...element,
      locked,
      open: false,
      basePath,
      key: `${basePath}/${element.title}`,
      children: children
        ? markActivePathSideBar(element.children, `${basePath}/${element.title}`, location)
        : null,
      collapse: !!children
    };
  });
};

const inactiveAll = (nodes) => {
  if (nodes instanceof Array)
    nodes.forEach((element) => {
      element.open = false;
      if (element.children) inactiveAll(element.children);
    });
};

const setPermisions = ({ nodes, permissions }) => {
  if (nodes && nodes instanceof Array) {
    nodes.forEach((element) => {
      if (!element.path?.endsWith('/')) element.path += '/';
      element.allowed = permissions?.includes(element.path);
      if (element.children) {
        element.allowed = true;
        setPermisions({ nodes: element.children, permissions });
      }
      element.locked = !element.allowed;
    });
  }
};

const hideChildlessNodes = ({ nodes }) => {
  if (nodes && nodes instanceof Array) {
    nodes.forEach((element) => {
      if (element.children) {
        const childs = element.children.find((item) => !item.locked);
        if (!childs) element.locked = true;
        hideChildlessNodes({ nodes: element.children });
      }
    });
  }
};

const selectActive = ({ nodes, path, type }) => {
  if (!nodes || !path) return;
  if (nodes instanceof Array) {
    nodes.forEach((element) => {
      if (type === 'location') element.open = path.startsWith(element.path);
      else element.open = path.startsWith(element.key);
      if (element.children) selectActive({ nodes: element.children, path, type });
    });
  }
};

const searchByRoute = (nodes, path) => {
  const selected = nodes.filter((element) => element.path == path);
  if (selected[0]) return { selected: selected[0], found: true };
  return { found: false, selected: null };
};

const register = (routes, nodes) => {
    routes.push({
      path: nodes.path?.endsWith('/') ? nodes.path : (nodes.path += '/'),
      key: nodes.key,
      title: nodes.title
    });
  if (nodes.children) {
    const newChild = nodes.children.map((item) => {
      return { ...item, key: `${item.key}` };
    });
    return newChild.reduce(register, routes);
  } else return routes;
};

export { reducer, searchByRoute, selectActive, inactiveAll, setPermisions, hideChildlessNodes };
